import script from "./PrivacyView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyView.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyView.vue?vue&type=style&index=0&id=bfec237a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfec237a"]])

export default __exports__